import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from 'src/app/services/api.service';
import { JwtService } from 'src/app/services/jwt.service';
import { MixpanelService } from 'src/app/services/mixpanel.service';
import { SynopsisPopupComponent } from './synopsis-popup/synopsis-popup.component';
import { FeedbackComponent } from './feedback/feedback.component';

@Component({
  selector: 'app-synopsis',
  templateUrl: './synopsis.component.html',
  styleUrls: ['./synopsis.component.css'],
})
export class SynopsisComponent {
  constructor(
    private jwt: JwtService,
    private mixpanel: MixpanelService,
    private dialog: MatDialog
  ) {}

  list: Array<{
    title: string;
    id: string;
    description: string;
    buttonName: string;
  }> = [
    {
      title: 'Summary report',
      id: 'summaryReport',
      description: 'Click "Open" to view user engagement and activity for clients using the Bigyellowfish and Yellowbox apps.',
      buttonName: 'Disabled',
    },
    {
      title: 'Client Engagement Report',
      id: 'clientEngagementReport',
      description: 'Click "Open" to view user engagement and other activities for clients using the Bigyellow app.',
      buttonName: 'Open',
    },
    {
      title: 'Client Capacity Report',
      id: 'clientCapacityReport',
      description: 'Click "Open" to access a report providing user-specific data on HPI, JDR, and capacities.',
      buttonName: 'Open',
    },
    {
      title: 'Statistics Report',
      id: 'statisticsReport',
      description: 'Click "Open" to access a report providing data on total downloads, activated users, and monthly active usage across all production clients.',
      buttonName: 'Open',
    },
    {
      title: 'Internal Admin Panel',
      id: 'internalAdminPanel',
      description: 'Click "Open" to access the Internal Admin Panel, which covers engagement, HPI, JDR & JDR variables at All levels from the Bigyellow app.',
      buttonName: 'Open',
    },
    {
      title: 'Psychologist Report',
      id: 'psychologistReport',
      description: 'Click "Open" to access the Psychologist Report, which provides mental health and behavioral insights from the Bigyellow app',
      buttonName: 'Open',
    },
    {
      title: 'Nutritionist Report',
      id: 'nutritionistReport',
      description: 'Click "Open" to access the Nutritionist Report, which provides nutritional insights and recommendations from the Bigyellow app.',
      buttonName: 'Open',
    },
    {
      title: 'Monthly Report',
      id: 'monthlyReport',
      description: 'Click "Open" to access the Monthly Report, which summarizes the key performance metrics for the month from the Bigyellow app.',
      buttonName: 'Open',
    },
    {
      title: 'Quarterly Report',
      id: 'quarterlyReport',
      description: 'Click "Open" to access the Quarterly Report, which summarizes the key performance metrics for the quarter from the Bigyellow app.',
      buttonName: 'Open',
    },
    {
      title: 'Annually Report',
      id: 'annuallyReport',
      description: 'Click "Open" to access the Annually Report, which summarizes the key performance metrics for the year from the Bigyellow app.',
      buttonName: 'Open',
    },
  ];

  buttonClicked: Array<boolean> = new Array(this.list.length).fill(false);

  ngOnInit() {
    this.jwt.check();
    this.mixpanel.track('page_view', {
      page: 'Synopsis',
      category: 'Dashboard',
      button: '-',
    });
  }

  onButtonClick(
    data: {
      title: string;
      id: string;
      description: string;
      buttonName: string;
    },
    i: number
  ) {
        this.buttonClicked[i] = true;
    this.mixpanel.track('button_click', {
      page: 'Synopsis',
      category: 'Dashboard',
      button: `${data.id} Download`,
    });
    const dialogRef = this.dialog.open(SynopsisPopupComponent, {
      data: data,
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((resp) => {
      this.buttonClicked[i] = false;
      if (resp) {
        this.dialog.open(FeedbackComponent, {
          disableClose: true,
          data: resp,
        });
      }
    });
  }
}
